import './TopList.css';
export var scrollContainer = '_jwlby60-3-8-0';